import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TITLE_PX, BODY_PX, HEIGHT_PX, publicImage } from "@/lib/content";

function Texts({ b, logo }) {
  const title = b.title && <h2 style={{ fontSize: TITLE_PX[b.size], fontFamily: b.font, lineHeight: 1.1 }} className="font-bold tracking-tight">{b.title}</h2>;
  return (
    <>
      {logo ? (
        <div className={`flex items-center gap-4 ${b.align === "center" ? "justify-center" : b.align === "right" ? "justify-end" : ""}`}>
          <img src={logo} alt="Assemblies of God" style={{ height: TITLE_PX[b.size] * 1.25, width: TITLE_PX[b.size] * 1.25 }} className="shrink-0 rounded-md bg-white object-contain p-1" data-testid="banner-logo" />
          {title}
        </div>
      ) : title}
      {b.body && <p style={{ fontSize: BODY_PX[b.size], fontFamily: b.font }} className="mt-3 whitespace-pre-line leading-relaxed opacity-95">{b.body}</p>}
    </>
  );
}

export function BlockView({ block: b, fallbackImage, fill, logo }) {
  const align = { textAlign: b.align };
  if (b.type === "divider") {
    return (
      <div style={{ background: b.bg }} className="px-4 py-4" data-testid={`block-${b.id}`}>
        <hr style={{ borderTop: `${b.divider_style === "double" ? 6 : 2}px ${b.divider_style} ${b.color}`, borderBottom: 0 }} />
      </div>
    );
  }
  if (b.type === "image") {
    return (
      <figure style={{ background: b.bg, color: b.color, ...align }} className="overflow-hidden rounded-xl p-3" data-testid={`block-${b.id}`}>
        {b.image_id ? <img src={publicImage(b.image_id)} alt={b.title || ""} className="max-h-[520px] w-full rounded-lg object-cover" /> : <div className="flex h-40 items-center justify-center rounded-lg border-2 border-dashed text-sm opacity-60">No image yet</div>}
        {b.title && <figcaption style={{ fontFamily: b.font, fontSize: BODY_PX[b.size] }} className="mt-2">{b.title}</figcaption>}
      </figure>
    );
  }
  if (b.type === "banner") {
    const img = b.image_id ? publicImage(b.image_id) : fallbackImage;
    const full = b.height === "full" && fill;
    return (
      <div data-testid={`block-${b.id}`} style={{ background: b.bg, color: b.color, minHeight: full ? undefined : HEIGHT_PX[b.height], ...align }}
        className={`relative flex overflow-hidden ${full ? "min-h-[280px] flex-1 rounded-none" : "rounded-xl"}`}>
        {img && <img src={img} alt="" className="absolute inset-0 h-full w-full object-cover" />}
        {img && <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/35 to-black/10" />}
        <div className={`relative flex w-full flex-col justify-end p-8 sm:p-12 ${b.align === "center" ? "items-center" : b.align === "right" ? "items-end" : "items-start"}`}>
          <div className="max-w-3xl"><Texts b={b} logo={logo} /></div>
        </div>
      </div>
    );
  }
  return (
    <section style={{ background: b.bg, color: b.color, ...align }} className="rounded-xl border border-slate-200/60 p-6 sm:p-8" data-testid={`block-${b.id}`}>
      <Texts b={b} />
    </section>
  );
}

export function PageBlocks({ page }) {
  const [blocks, setBlocks] = useState([]);
  useEffect(() => { api.get(`/content/${page}`).then((r) => setBlocks(r.data.blocks.filter((b) => b.visible))).catch(() => {}); }, [page]);
  if (!blocks.length) return null;
  return <div className="mb-8 space-y-4" data-testid={`page-blocks-${page}`}>{blocks.map((b) => <BlockView key={b.id} block={b} />)}</div>;
}
